import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import { createMPIView } from "app/main/utils/brokerUtils";
import { recalculateStrategy } from "app/services/strategyServices";
import { showSnackbar } from "app/main/utils/snackbarUtil";
import { useState } from "react";

function CardDestination(props) {
	const { destination, bestDestination, handleCheckLocation, index, strategyId, searchId } = props;
	const [recalculating, setRecalculating] = useState(false);

	const handleRecalculate = async () => {
		if (!strategyId || !searchId) {
			showSnackbar("Strategy ID and Search ID are required for recalculation", { variant: "error" });
			return;
		}

		setRecalculating(true);
		try {
			const payload = {
				searchId: searchId,
				dcluster: destination?.dcluster,
				ocluster: destination?.ocluster,
			};

			const result = await recalculateStrategy(strategyId, payload);
			showSnackbar("Strategy recalculated successfully with market destination data!", { variant: "success" });
			console.log("Strategy recalculated:", result);
		} catch (error) {
			console.error("Error recalculating strategy:", error);
			showSnackbar(`Error recalculating strategy: ${error.message || "Unknown error"}`, {
				variant: "error",
			});
		} finally {
			setRecalculating(false);
		}
	};

	return (
		<>
			<Card variant="outlined" className="w-full">
				<CardContent className="p-10" style={{ paddingBottom: 10 }}>
					<div className="flex flex-col">
						<div className="flex">
							<Typography className="text-start text-12">
								{destination?.destination} ({destination?.dcluster})
							</Typography>
							<div className="flex ml-auto">
								{strategyId && searchId && (
									<Tooltip title="Recalculate strategy with this destination data">
										<IconButton size="small" onClick={handleRecalculate} disabled={recalculating} className="p-2 mr-2">
											<Icon className={`text-16 ${recalculating ? "animate-spin" : ""}`}>
												{recalculating ? "sync" : "refresh"}
											</Icon>
										</IconButton>
									</Tooltip>
								)}
								<Checkbox
									checked={bestDestination[index]?.value}
									className="-mt-10"
									size="small"
									onChange={(e) => handleCheckLocation(index, e)}
									disabled={
										!bestDestination[index]?.value &&
										bestDestination?.filter((destination) => destination?.value)?.length === 1
									}
								/>
							</div>
						</div>
						<div className="flex">
							{createMPIView({ rank_mci: destination?.rank_mci }, true)}
							<Typography className="text-12 ml-auto">{`# loads ${destination.count}`}</Typography>
						</div>
						<div className="flex">
							<Typography className="text-12 ml-auto">{`$${destination?.stats?.rateStats?.mean?.toFixed(
								2
							)} (RPM $${destination?.stats?.rpmStats?.mean?.toFixed(2)})`}</Typography>
						</div>
					</div>
				</CardContent>
			</Card>
		</>
	);
}

export default CardDestination;
